module.exports = __webpack_public_path__ + "img/microphone_record.14acd89b.svg";